import { combineReducers } from "redux";
import integrations from "./integrations";

export default combineReducers({
  integrations: combineReducers(integrations),
});
